





























 import { Component, Vue, Prop } from 'vue-property-decorator';
 import { percentFilter } from '@/filters/percent';
 import { formattedDate } from '@/filters/date';
 import { formattedYearsInterval } from '@/filters/date';
 import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import CropIcons from '@/utils/iconCropTypes';

@Component({
  name: 'MonitoringStatus',
  components: {
    AgroIcon: AgroIcons,
  },
  filters: {
    percentFilter,
    formattedDate,
    formattedYearsInterval,
  }
})
export default class MonitoringStatus extends Vue {
  @Prop({type: Boolean, default: false})
  private finished!: boolean;

  @Prop(String)
  private cropType!: string;

  @Prop(Number)
  private monitoringYear!: number;

  @Prop(Date)
  private lastUpdate!: Date;

  private get cropTypeIconName() {
    return CropIcons.fromText(this.cropType);
  }

}
